import { Link } from "react-router-dom";
import { publicUrl } from "@/lib/storage";
import VideoPlayer from "@/components/VideoPlayer";

export type MediaCardPost = {
  id: string;
  slug: string;
  title: string;
  subtitle: string | null;
  cover_image_path: string | null;
  thumbnail_url?: string | null;
  video_url: string | null;
  content_type?: string | null;
  published_at: string | null;
};

/** One card for any Media Hub item — video or SIIS original. */
const MediaCard = ({ post }: { post: MediaCardPost }) => {
  const img = publicUrl(post.cover_image_path) ?? post.thumbnail_url ?? null;
  const isArticle = post.content_type === "original";

  const media = post.video_url ? (
    <VideoPlayer url={post.video_url} />
  ) : img ? (
    <img src={img} alt={post.title} loading="lazy" className="w-full h-full object-cover" />
  ) : (
    <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">
      Say It In Sports
    </div>
  );

  const body = (
    <div className="p-5">
      <h3 className="font-display text-2xl leading-tight">{post.title}</h3>
      {post.subtitle && <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{post.subtitle}</p>}
      {post.published_at && (
        <p className="text-xs text-muted-foreground mt-3">
          {new Date(post.published_at).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      )}
    </div>
  );

  return (
    <article className="rounded-2xl overflow-hidden bg-card shadow-card hover:shadow-bold transition-all">
      <div className="aspect-video bg-muted overflow-hidden">{media}</div>
      {isArticle ? (
        <Link to={`/media-hub/story/${post.slug}`} className="block hover:text-primary transition-colors">
          {body}
        </Link>
      ) : (
        body
      )}
    </article>
  );
};

export default MediaCard;
